import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Button, Pagination, Space } from 'tdesign-react';

import NovaDialog from '@/components/dialog';
import { AiMusicReq, UrlInfo } from '@/interface/aigc';

import AigcMusicComponent from '../AigcMusicComponent';
import styles from './index.module.less';

export interface AigcMusicDialogProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: (selectedMusic: UrlInfo, promptText: string) => void;
  data: {
    promptText: string,
  }
}

const AigcMusicDialog: React.FC<AigcMusicDialogProps> = (props) => {
  const { visible, onClose, onConfirm, data } = props;
  const [src, setSrc] = useState<UrlInfo>();
  const [prompt, setPrompt] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    size: 10,
    total: 0,
  });

  useEffect(() => {
    if (!visible) {
      setSrc(undefined);
      setPagination(pre => ({ ...pre, page: 1 }));
    }
  }, [visible]);

  const handleConfirm = () => {
    onConfirm({
      url: src?.url || '',
      name: src?.name || '未命名',
      volume: src?.volume || 100,
    }, prompt);
    onClose();
  };

  const getHeader = () => (
		<div className={styles.modalTitle}>
			<span style={{ flexGrow: 1 }}>AI 智能音乐</span>
		</div>
  );

  const getFooter = () => (
    <div className={classNames('nova-modal-fixed-bottom-wrapper-end', styles.footer)}>
      <Pagination
        total={pagination.total}
        totalContent={false}
        defaultPageSize={10}
        pageSizeOptions={[5, 10, 20, 50, 100]}
        current={pagination.page}
        pageSize={pagination.size}
        onChange={v => setPagination(pre => ({
          ...pre,
          page: v.current,
          size: v.pageSize,
        }))}
      />
      <Space size={10}>
        <Button
          className="nova-info-button"
          size="medium"
          block
          theme="default"
          onClick={onClose}
        >
          取消
        </Button>
        <Button
          className="nova-info-button"
          size="medium"
          block
          onClick={handleConfirm}
        >
          确定
        </Button>
      </Space>
    </div>
  );

  const dialogConfig = {
    visible,
    closeBtn: false,
    destroyOnClose: true,
    closeOnOverlayClick: false,
    width: '90vw',
    height: '800px',
    style: { overflow: 'auto' },
    className: styles.dialog,
    onCancel: onClose,
    onConfirm: handleConfirm,
    onClose,
    header: getHeader(),
    footer: getFooter(),
  };

  const getSrc = (src: UrlInfo) => {
    setSrc(src);
  };

  const getData = (data: AiMusicReq) => {
    setPrompt(data.prompt || '');
  };

  return (
		<NovaDialog dialogConfig={dialogConfig}>
			<AigcMusicComponent
				visible={visible}
				data={data}
				getSrc={getSrc}
				getData={getData}
        pagination={pagination}
        onPageChange={v => setPagination(v)}
			/>
		</NovaDialog>
  );
};

export default AigcMusicDialog;
